import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocationStrategy } from '@angular/common';
import { IBaseModel } from '../models/base.model';
import { IFormulaRiscoInerente } from '../models/formula-risco-inerente.model';

@Injectable({
  providedIn: 'root'
})
export class FormulaRiscoInerenteService extends BaseService {


  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(criteriosAvaliacaoRiscosId: string, ativo: boolean, simplificado = false): Promise<IBaseModel<IFormulaRiscoInerente[]>> {
    let params = new HttpParams();
    params = params.append('criteriosAvaliacaoRiscosId', criteriosAvaliacaoRiscosId || '0');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<IFormulaRiscoInerente[]>>(`${this.apiBaseUrl}/formulaRiscoInerente`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<IFormulaRiscoInerente>> {
    return this.httpClient
      .get<IBaseModel<IFormulaRiscoInerente>>(`${this.apiBaseUrl}/formulaRiscoInerente/${id}`)
      .toPromise();
  }

  public async inserir(data: IFormulaRiscoInerente): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/formulaRiscoInerente/`, data)
      .toPromise();
  }

  public async atualizar(data: IFormulaRiscoInerente): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/formulaRiscoInerente/${data.id}`, data)
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/formulaRiscoInerente/${id}/excluir`, {})
      .toPromise();
  }
}
